import { useEffect, useState } from "react"
import Hearder from "../commun/Hearder"
import SideBar from "../commun/SideBar"
import { AddMealPlan, PropertyMealplan, PropertyMealplanDelete } from "../../Services/Service";
import swal from "sweetalert";
import Select from "react-select";

export const MealPlan = () => {
    const [loading, setLoading] = useState(false);
    const [mealplan, setMealplan] = useState([]);
    const [selectedCode, setSelectedCode] = useState("");
    const [selectedName, setSelectedName] = useState("");
    const [selectedDescription, setSelectedDescription] = useState("");
    const [filteredMealplan, setFilteredMealplan] = useState([]);

    useEffect(() => {
        const FetchMealplan = async () => {
            setLoading(true);
            try {
                const result = await PropertyMealplan();
                // if (Array.isArray(result)) setMealplan(result);
                if (Array.isArray(result)) {
                    setMealplan(result);
                    setFilteredMealplan(result); // initially show all
                }
            }
            catch (error) {
                console.log("error get meal plan", error);
            } finally {
                setLoading(false);
            }
        }
        FetchMealplan();
    }, []);

    const [form, setForm] = useState({
        MealPlanID: 0,
        Code: "",
        Name: "",
        Description: "",
        IsActive: 1
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm({
            ...form,
            [name]: type === "checkbox" ? (checked ? 1 : 0) : value
        });
    };


    const handleAddClick = () => {
        setForm({
            MealPlanID: 0,
            Code: "",
            Name: "",
            Description: "",
            IsActive: true,
        });
    };

    // Open Edit modal
    const handleEditClick = (plan) => {
        setForm({
            MealPlanID: plan.MealPlanID,
            Code: plan.Code,
            Name: plan.Name,
            Description: plan.Description,
            IsActive: plan.IsActive,
        });
    };

    // Submit form
    const handleSubmit = async () => {

        if (!form.Code.trim() || !form.Name.trim()) {
            swal("Please enter First Code and Name !", {
                icon: "warning",
                buttons: {
                    confirm: {
                        text: "OK",
                        className: "btn btn-warning",
                    },
                },
            });
            return;
        }

        try {
            setLoading(true);
            await AddMealPlan(
                form.MealPlanID,
                form.Code,
                form.Name,
                form.Description,
                form.IsActive
            );
            // Clear form
            setForm({
                MealPlanID: 0,
                Code: "",
                Name: "",
                Description: "",
                IsActive: true
            })

            const modalEl = document.getElementById("Add-Meal-Plan");
            if (modalEl) {
                const modalInstance = window.bootstrap.Modal.getInstance(modalEl);
                if (modalInstance) {
                    modalInstance.hide();
                }
            }

            swal("Meal Plan Saved Successfully", {
                icon: "success",
                buttons: {
                    confirm: {
                        text: "OK",
                        className: "btn btn-success",
                    },
                },
            });

            // Refresh meal plan list
            const result = await PropertyMealplan();
            if (Array.isArray(result)) setMealplan(result);
        } catch (error) {
            console.log("error adding meal plan", error);
        } finally {
            setLoading(false);
        }
    };

    // Delete handler
    const handleDelete = async (MealPlanID) => {
        try {
            const confirm = await swal({
                title: "Are you sure?",
                icon: "warning",
                buttons: {
                    cancel: "Cancel",
                    confirm: {
                        text: "Delete",
                        value: true,
                        visible: true,
                        className: "btn-danger",
                        closeModal: true,
                    },
                },
                dangerMode: true,
            });

            if (confirm) {
                await PropertyMealplanDelete(MealPlanID);

                swal("Meal Plan Deleted Successfully", {
                    icon: "success",
                });

                // Refresh list
                const result = await PropertyMealplan();
                if (Array.isArray(result)) setMealplan(result);
            }
        } catch (error) {
            console.log("error deleting meal plan", error);
        }
    };

    useEffect(() => {
        let filtered = mealplan;

        if (selectedCode && selectedCode.value) {
            filtered = filtered.filter(mp => mp.Code === selectedCode.value);
        }
        if (selectedName && selectedName.value) {
            filtered = filtered.filter(mp => mp.Name === selectedName.value);
        }
        if (selectedDescription && selectedDescription.value) {
            filtered = filtered.filter(mp => mp.Description === selectedDescription.value);
        }

        setFilteredMealplan(filtered);
    }, [selectedCode, selectedName, selectedDescription, mealplan]);

    const handleClear = (e) => {
        e.preventDefault();
        setSelectedCode("");
        setSelectedName("");
        setSelectedDescription("");
        setFilteredMealplan(mealplan); // reset table
    };

    // Prepare options for react-select
    const codeOptions = mealplan.map(mp => ({ value: mp.Code, label: mp.Code || "No code" }));
    const nameOptions = mealplan.map(mp => ({ value: mp.Name, label: mp.Name || "No name" }));
    const descriptionOptions = mealplan.map(mp => ({ value: mp.Description, label: mp.Description || "No description" }));


    return (
        <>
            {loading && (
                <div className="fullscreen-loader">
                    <div className="fas fa-spinner fa-spin fa-3x " role="status"></div>
                </div>
            )}
            <div className="wrapper">
                <SideBar />
                <div className="main-panel">
                    <Hearder />
                    <div className="container">
                        <div className="page-inner">
                            <div className="row">
                                <div className="col-md-12">

                                    <div className="card">
                                        <div className="card-header">
                                         <div className="d-flex justify-content-between align-items-center">
                                            <h4 className="card-title">Meal Plan List</h4>
                                                    <button type="button" className="btn btn-primary btn-sm waves-effect waves-light mt-1" data-bs-toggle="modal" data-bs-target="#Add-Meal-Plan" onClick={handleAddClick}>Add </button>
                                                </div>
                                            
                                        </div>
                                        <div className="card-body">
                                            <form className="mb-0">
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <div className="input-block">
                                                            <label>Code</label>
                                                            {/* <select
                                                                className="form-select form-control"
                                                                value={selectedCode}
                                                                onChange={(e) => setSelectedCode(e.target.value)}
                                                            >
                                                                <option value="">Select code</option>
                                                                {mealplan.map((mp) => (
                                                                    <option key={mp.MealPlanID} value={mp.Code}>
                                                                        {mp.Code || "No code"}
                                                                    </option>
                                                                ))}
                                                            </select> */}
                                                            <Select
                                                                options={codeOptions}
                                                                value={selectedCode}
                                                                onChange={setSelectedCode}
                                                                isClearable
                                                                placeholder="Select code"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="input-block">
                                                            <label>Name</label>
                                                            {/* <select
                                                                className="form-select form-control"
                                                                value={selectedName}
                                                                onChange={(e) => setSelectedName(e.target.value)}
                                                            >
                                                                <option value="">Select Name</option>
                                                                {mealplan.map((mp) => (
                                                                    <option key={mp.MealPlanID} value={mp.Name}>
                                                                        {mp.Name || "No name"}
                                                                    </option>
                                                                ))}
                                                            </select> */}
                                                            <Select
                                                                options={nameOptions}
                                                                value={selectedName}
                                                                onChange={setSelectedName}
                                                                isClearable
                                                                placeholder="Select name"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="input-block">
                                                            <label>Description</label>
                                                            {/* <select
                                                                className="form-select form-control"
                                                                value={selectedDescription}
                                                                onChange={(e) => setSelectedDescription(e.target.value)}
                                                            >
                                                                <option value="">Select description</option>
                                                                {mealplan.map((mp) => (
                                                                    <option key={mp.MealPlanID} value={mp.Description}>
                                                                        {mp.Description || "No description"}
                                                                    </option>
                                                                ))}
                                                            </select> */}
                                                            <Select
                                                                options={descriptionOptions}
                                                                value={selectedDescription}
                                                                onChange={setSelectedDescription}
                                                                isClearable
                                                                placeholder="Select description"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <div className="input-block" style={{ marginTop: "19px" }}>
                                                            <button type="button" className="btn btn-primary me-2" >Filter</button>
                                                            <button className="btn btn-danger" onClick={handleClear}>Clear</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="table-responsive">
                                               
                                                <table
                                                    className="display table table-striped table-hover basic-datatables"
                                                >
                                                    <thead>
                                                        <tr>
                                                            <th>Code</th>
                                                            <th>Name</th>
                                                            <th>Description</th>
                                                            <th>Status</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {filteredMealplan.length > 0 ? (
                                                            filteredMealplan.map((plan) => (
                                                                <tr key={plan.MealPlanID}>
                                                                    <td>{plan.Code}</td>
                                                                    <td>{plan.Name}</td>
                                                                    <td>{plan.Description}</td>
                                                                    <td>
                                                                        {plan.IsActive ? (
                                                                            <span className="badge bg-success">Active</span>
                                                                        ) : (
                                                                            <span className="badge bg-danger">Inactive</span>
                                                                        )}
                                                                    </td>

                                                                    <td>
                                                                        <button type="button" className="btn btn-primary btn-sm waves-effect waves-light py-1 px-2 me-2" data-bs-toggle="modal" data-bs-target="#Add-Meal-Plan" onClick={() => handleEditClick(plan)}><i className="fas fa-edit"></i></button>
                                                                        <button className="btn btn-sm btn-danger py-1 px-2" onClick={() => handleDelete(plan.MealPlanID)}><i className="fas fa-trash"></i></button>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="5" className="text-center">
                                                                    No records found
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>

                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>




                    {/* meal plan Model */}
                    <div
                        id="Add-Meal-Plan"
                        className="modal fade"
                        tabIndex={-1}
                        role="dialog"
                        aria-hidden="true"
                    >
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h4 className="modal-title"> {form.MealPlanID === 0 ? "Add Meal Plan" : "Edit Meal Plan"}</h4>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                    />
                                </div>
                                <div className="modal-body">

                                    <div className="mb-3">
                                        <label className="form-label">Code</label>
                                        <input type="text" className="form-control" placeholder="Enter code" name="Code" value={form.Code}
                                            onChange={handleChange} />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Name</label>
                                        <input type="text" className="form-control" placeholder="Enter Name" name="Name" value={form.Name}
                                            onChange={handleChange} />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Description</label>
                                        <textarea type="text" className="form-control" placeholder="Enter Description" name="Description" value={form.Description}
                                            onChange={handleChange} />
                                    </div>
                                    <div className="mb-3">
                                        <div className="d-flex">
                                            <label className="form-label me-2 ">status </label>
                                            <input type="checkbox" style={{ marginTop: "-7px" }} name="IsActive" checked={form.IsActive === 1}
                                                onChange={handleChange} />
                                        </div>
                                    </div>

                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-info waves-effect waves-light"
                                        onClick={handleSubmit}
                                    >
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </>
    )
}
